interface Step {
  label: string;
  description?: string;
}

interface StepProgressProps {
  steps: Step[];
  currentStep: number;
}

export default function StepProgress({ steps, currentStep }: StepProgressProps) {
  return (
    <div className="flex items-center gap-0">
      {steps.map((step, idx) => {
        const isCompleted = idx < currentStep;
        const isCurrent = idx === currentStep;

        return (
          <div key={idx} className="flex items-center">
            <div className="flex items-center gap-2">
              <div
                className={`flex size-8 items-center justify-center rounded-full text-xs font-bold transition-colors ${
                  isCompleted
                    ? 'bg-emerald-500 text-white'
                    : isCurrent
                    ? 'bg-primary text-white'
                    : 'border-2 border-slate-200 bg-white text-text-faint'
                }`}
              >
                {isCompleted ? (
                  <span className="material-symbols-outlined" style={{ fontSize: 16 }}>check</span>
                ) : (
                  idx + 1
                )}
              </div>
              <div className="min-w-0">
                <p
                  className={`text-xs font-bold ${
                    isCurrent ? 'text-primary' : isCompleted ? 'text-text-main' : 'text-text-faint'
                  }`}
                >
                  {step.label}
                </p>
                {step.description && (
                  <p className="text-[10px] text-text-faint">{step.description}</p>
                )}
              </div>
            </div>
            {idx < steps.length - 1 && (
              <div
                className={`mx-3 h-0.5 w-12 rounded-full ${
                  isCompleted ? 'bg-emerald-500' : 'bg-slate-200'
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
